import React, {useReducer} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import Tile from 'app/components/tile/Tile';
import TileContainer from 'app/components/tile/TileContainer';
import {Subheading} from 'app/styles/heading';
import {Helmet} from 'react-helmet-async';
import {string} from 'prop-types';
import {fetchCupRankings} from 'app/routes/cup/CupPageActions';
import {CupRankingsPageReducer} from 'app/routes/cup/CupPageReducer';
import {CompetitionRankingsContent} from 'app/components/competitions/CompetitionRankings';
import {useParams} from 'react-router';
import {useFetchData, useRestoreData} from 'app/hooks/dataHooks';
import {LOADING_MESSAGE, LoadingIndicator} from '@fupa/fupa-uikit';

const CupRankingsPage = ({defaultMeta, baseUrl, dispatchRedux}) => {
  const {restoredData} = useRestoreData('CupRankingsPage');
  const {cupSlug, seasonSlug} = useParams();
  const initialState = restoredData ?? {
    isFetching: false,
    data: {},
  };
  const [state, dispatch] = useReducer(CupRankingsPageReducer, initialState);

  const loadData = () => fetchCupRankings(cupSlug, seasonSlug, dispatchRedux)(dispatch, state);
  const {data, isFetching} = state;
  useFetchData(state, loadData, 'CupRankingsPage');

  const meta = [{name: 'description', content: 'Rankings - ' + defaultMeta}];

  const content = isFetching ? (
    <LoadingIndicator message={LOADING_MESSAGE.loadingData} bgColor={true} />
  ) : (
    <>
      <Subheading variant='subheading2'>Turnier-Rankings</Subheading>
      <TileContainer>
        <Tile label='Torjäger' type='1' icon='football' link={`${baseUrl}/scorers`} />
      </TileContainer>
      <Subheading variant='subheading2'>Top-Facts</Subheading>
      <CompetitionRankingsContent stats={data} />
    </>
  );

  return (
    <ContentAdDesktop superbannerOnly top='7.125rem'>
      <Helmet title='Rankings - ' meta={meta} />
      {content}
    </ContentAdDesktop>
  );
};

CupRankingsPage.propTypes = {
  defaultMeta: string.isRequired,
};

export default CupRankingsPage;
